import { en } from "./en.js";
import { es } from "./es.js";
import { pt } from "./pt.js";
const locales = {
    es: es,
    pt: pt,
    en: en
};
const i18n = locales;
export default i18n;
